import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useAuth } from 'react-oidc-context';

import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import { Box, Button, ButtonBase, ListItem, ListItemButton, ListItemText } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

export default ({ show, onClose }) => {
  return (

    <Modal
      show={show}
      onHide={onClose}
      dialogClassName="modal-70w"
      aria-labelledby="example-custom-modal-styling-title"
    >

      <Modal.Body style={{ padding: '2vw 2vw', textAlign: 'center' }}>

        <p style={{ fontSize: '1.5vw' }}>Specia Privacy Policy</p>
        <p style={{ fontSize: '0.8vw', padding: '0vw', textAlign: 'center' }}>Our ongoing commitment to protecting your privacy and Personal Information responsibly</p>

        <div style={{ margin: '2vw 0.5vw 0vw 0.5vw', backgroundColor: 'rgb(0, 0, 0, 0.03)', borderRadius: '1vw', fontSize: '0.8vw', overflow: 'hidden', maxHeight: '55vh', overflowY: 'scroll', padding: '1vw', textAlign: 'left' }}>
          <p>
            <strong>Effective Date:</strong>
            {' '}
            28 June 2025
          </p>
          <p>Specia Pty Ltd (ABN: 56 655 818 607), a subsidiary of Spectar Group (ABN: 33 616 780 548), ("Specia", "we", "our", "us") is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, store, and disclose your information through our services, website (platform.specia.ai), and related platforms.</p>
          <p>By accessing or using our website or services, you consent to the terms of this Privacy Policy and our Terms of Use.</p>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>What We Collect</p>
          <p>We may collect the following types of personal and business information:</p>
          <ul>
            <li>Full name and business name</li>
            <li>Email address and contact number</li>
            <li>ABN and Tax Agent Number (where required)</li>
            <li>IP address, browser type, and usage analytics</li>
            <li>Payment information (processed via secure third parties)</li>
            <li>Documents uploaded by users or accessed through third-party integrations (e.g., ATO, Xero, MYOB, Google Drive)</li>
          </ul>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>How We Collect Information </p>
          <p>We collect personal information:</p>
          <ul>
            <li>When you register for our services</li>
            <li>When you use our platform or engage with support</li>
            <li>When you upload documents or integrate third-party tools</li>
            <li>From publicly available sources or your authorised representatives</li>
          </ul>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>Why We Collect Information</p>
          <p style={{ fontWeight: '500' }}>We collect personal information to:</p>
          <ul>
            <li>Provide and improve our platform and services</li>
            <li>Verify your identity and enable secure logins</li>
            <li>Maintain compliance with regulatory requirements (e.g., ATO, TPB)</li>
            <li>Personalise your user experience</li>
            <li>Respond to support requests and communications</li>
          </ul>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>Use of Cookies and Analytics</p>
          <p>Our platform uses cookies and analytics tools to:</p>
          <ul>
            <li>Track session data and user interactions</li>
            <li>Enhance functionality and personalise content</li>
            <li>Monitor platform performance</li>
          </ul>
          <p>You can control cookie settings in your browser; however, disabling them may limit functionality.</p>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>How We Store and Protect Your Information</p>
          <ul>
            <li>All data is hosted securely in Microsoft Azure data centres located in Australia</li>
            <li>Access is restricted via encryption, authentication, and monitoring tools</li>
            <li>We comply with the Privacy Act 1988 (Cth), the Australian Privacy Principles (APPs), and ISO27001 standards</li>
          </ul>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>Data Disclosure</p>
          <p>We only disclose personal data:</p>
          <ul>
            <li>With your explicit consent</li>
            <li>To third-party providers under strict confidentiality (e.g., payment processors, document storage, analytics)</li>
            <li>As required by law or court order</li>
            <li>During corporate acquisitions or asset transfers (with your rights preserved)</li>
          </ul>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>Your Rights</p>
          <p>You can:</p>
          <ul>
            <li>Request access or correction to your personal data</li>
            <li>Withdraw consent or delete your account</li>
            <li>File a complaint to our Privacy Officer at privacy@specia.ai</li>
          </ul>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>Retention and Deletion</p>
          <p>We retain personal data only as long as necessary to provide our services or comply with legal obligations. You may request data deletion subject to applicable tax and regulatory retention requirements.</p>
          <p style={{ fontSize: '0.9vw', fontWeight: '500' }}>Updates to This Policy</p>
          <p>We may revise this policy periodically. The latest version will always be posted on our website. Continued use of the platform constitutes your acceptance of the updated policy.</p>
        </div>

        <Button
          onClick={onClose}
          variant="outlined"
          style={{
            borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '0', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
            width: '40%', marginTop: '2vw' }}
        >
          Done
        </Button>

      </Modal.Body>
    </Modal>
  );
};


